/**
 * Junip rating fallback for product cards.
 *
 * Port of `junipRating()` from the old `algolia_instant_search_product.liquid`.
 * Products with blended review metafields are rendered server-side by
 * `product-card-rating.liquid`; only the rest reach this file.
 *
 * The markup below is copied verbatim from the Algolia template so the
 * existing stylesheet keeps applying. What changed is the transport: the old
 * code issued one `api.juniphq.com` request per card (~50 on a full PLP), this
 * batches every card on the page into one request and refills as the grid
 * grows via load-more.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://api.juniphq.com/v1/products';
  var BATCH_SIZE = 50;

  // Cache keyed by product id so load-more never refetches a known rating.
  var cache = {};
  var inFlight = {};

  function storeKey() {
    return window.__theme && window.__theme.junip && window.__theme.junip.storekey;
  }

  // customRound() — star fill as a width percentage.
  function fillStyle(average) {
    return average > 0 ? 'width:' + (average * 100) / 5 + '%' : 'width:0%;';
  }

  function markup(average, count) {
    var noun = count === 1 ? 'Review' : 'Reviews';

    return (
      '<div class="flex mr-2">' +
      '<div class="ratings"> \n' +
      '            <div class="empty-stars"></div>\n' +
      '            <div class="full-stars" style="' +
      fillStyle(average) +
      '"></div>\n' +
      '          </div>' +
      '</div>\n' +
      '            <p class="leading-none text-black-900 max-md:hidden">\n' +
      '                  <span class="font-brother text-sm font-semibold capitalize tracking-[0.75px] underline"><span>' +
      count +
      ' </span> ' +
      noun +
      '</span>\n' +
      '              </p>\n' +
      '            <span class="font-brother text-sm font-semibold capitalize tracking-[0.75px] md:hidden">\n' +
      '              <span class="flex"> ' +
      count +
      '</span>\n' +
      '            </span>'
    );
  }

  function paint(id) {
    var data = cache[id];
    if (!data) return;

    var cells = document.querySelectorAll('[data-junip-product="' + id + '"]');
    for (var i = 0; i < cells.length; i++) {
      if (cells[i].dataset.junipPainted === 'true') continue;
      // No reviews -> keep the markup (so the row still takes up its space and
      // every card in the grid stays aligned) but hide it, instead of showing
      // a "0 stars (0 Reviews)" line.
      cells[i].classList.toggle('invisible', !data.count || data.count < 1);
      cells[i].innerHTML = markup(data.average, data.count);
      cells[i].dataset.junipPainted = 'true';
    }
  }

  function fetchBatch(ids) {
    var key = storeKey();
    if (!key || !ids.length) return;

    ids.forEach(function (id) {
      inFlight[id] = true;
    });

    fetch(ENDPOINT + '?filter[remote_ids]=' + ids.join(','), {
      headers: {'Junip-Store-Key': key},
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not OK.');
        return response.json();
      })
      .then(function (data) {
        (data.products || []).forEach(function (product) {
          cache[product.remote_id] = {
            average: product.rating_average,
            count: product.rating_count,
          };
          paint(product.remote_id);
        });
      })
      .catch(function () {
        // Same as the original: a failed lookup leaves the cell empty rather
        // than rendering a zero-star placeholder.
      })
      .then(function () {
        ids.forEach(function (id) {
          delete inFlight[id];
        });
      });
  }

  function collect() {
    var cells = document.querySelectorAll('[data-junip-product]');
    var pending = [];
    var seen = {};

    for (var i = 0; i < cells.length; i++) {
      var id = cells[i].dataset.junipProduct;
      if (!id || seen[id]) continue;
      seen[id] = true;

      if (cache[id]) {
        paint(id);
      } else if (!inFlight[id]) {
        pending.push(id);
      }
    }

    for (var j = 0; j < pending.length; j += BATCH_SIZE) {
      fetchBatch(pending.slice(j, j + BATCH_SIZE));
    }
  }

  window.refreshCardRatings = collect;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
})();
